import { render } from "./QueryCompleteView.vue?vue&type=template&id=2512d32f&scoped=true"
import script from "./QueryCompleteView.vue?vue&type=script&lang=js"
export * from "./QueryCompleteView.vue?vue&type=script&lang=js"

import "./QueryCompleteView.vue?vue&type=style&index=0&id=2512d32f&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2512d32f"]])

export default __exports__